import React from "react";
import { Field, reduxForm } from "redux-form";
import { renderTextField } from "../helpers/formFields";
import validator from 'validator';

import Button from '@mui/material/Button';


class SendEmailForm extends React.Component {

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Field
                    name="email"
                    id="email"
                    component={renderTextField}
                    label="Email Address"
                    margin="normal"
                    required
                    fullWidth
                    // InputLabelProps={{ shrink: true }}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Send link to email
                </Button>
            </form>

        )
    }

}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.email) {
        errors.email = 'You must enter a email';    
    }

    if (formValues.email) {
        if (!validator.isEmail(formValues.email)) {
            errors.email = 'You must enter a valid email';    
        }
    }    

    return errors;
}

export default reduxForm({
    form: 'sendEmailForm',
    validate: validate
})(SendEmailForm)